var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.125C0 2.2962 0.32924 1.50134 0.915291 0.915291C1.50134 0.32924 2.2962 0 3.125 0H14.875C15.7038 0 16.4987 0.32924 17.0847 0.915291C17.6708 1.50134 18 2.2962 18 3.125V14.875C18 15.7038 17.6708 16.4987 17.0847 17.0847C16.4987 17.6708 15.7038 18 14.875 18H3.125C2.2962 18 1.50134 17.6708 0.915291 17.0847C0.32924 16.4987 0 15.7038 0 14.875V3.125Z",
    fill: "url(#paint0_radial_11952_8672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 16.6925L10.2375 9.5125C10.075 9.34998 9.88209 9.22106 9.66976 9.13311C9.45742 9.04515 9.22985 8.99988 9.00002 8.99988C8.77019 8.99988 8.54261 9.04515 8.33028 9.13311C8.11795 9.22106 7.92502 9.34998 7.76252 9.5125L0.58252 16.6925C0.87143 17.0973 1.25292 17.4272 1.69519 17.6546C2.13746 17.8821 2.62769 18.0005 3.12502 18H14.875C15.3723 18.0005 15.8626 17.8821 16.3048 17.6546C16.7471 17.4272 17.1286 17.0973 17.4175 16.6925Z",
    fill: "url(#paint1_linear_11952_8672)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.5C10.5 4.96957 10.7107 4.46086 11.0858 4.08579C11.4609 3.71071 11.9696 3.5 12.5 3.5C13.0304 3.5 13.5391 3.71071 13.9142 4.08579C14.2893 4.46086 14.5 4.96957 14.5 5.5C14.5 6.03043 14.2893 6.53914 13.9142 6.91421C13.5391 7.28929 13.0304 7.5 12.5 7.5C11.9696 7.5 11.4609 7.28929 11.0858 6.91421C10.7107 6.53914 10.5 6.03043 10.5 5.5Z",
    fill: "url(#paint2_linear_11952_8672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11952_8672",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.071 -10.125) rotate(51.687) scale(49.773 45.2718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#367AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11952_8672",
    x1: 6.59502,
    y1: 9,
    x2: 8.64452,
    y2: 18.4675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11952_8672",
    x1: 11.7,
    y1: 3.0555,
    x2: 13.1615,
    y2: 8.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.4579063f700dff4d9ffb0bcc24e4e7b4.svg";
export { ForwardRef as ReactComponent };